var _path, _path2, _path3, _path4, _polygon, _path5, _rect, _polygon2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect2, _rect3, _rect4, _path15, _path16, _circle, _circle2, _circle3, _polyline, _rect5, _rect6, _rect7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderConfirmation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    "data-imageid": "order-confirmation-6",
    imageName: "Order Confirmed",
    className: "illustrations_image",
    style: {
      width: 200
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.78,65c-26.44,10.27-46,36.31-49.92,67.82-3.26,26.54,4.53,55.88,50.36,64.24,89.18,16.26,172.71,20.9,194-23S325,55,279.76,50.14C243.77,46.27,167.42,44.9,115.78,65Z",
    fill: "#e6e6e6",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M221.59,85.64s35.54,9.9,25.34,40.45L226,124.42Z",
    fill: "#00288f",
    className: "target-color"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221.59,85.64s35.54,9.9,25.34,40.45L226,124.42Z",
    fill: "#fff",
    opacity: 0.44
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187.15,77.64l15.76,2.76s56.91,6.18,32.21,52.34-85.89,20.43-85.89,20.43S96.51,71.66,187.15,77.64Z",
    fill: "#00288f",
    className: "target-color"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "191.84 49.06 186.51 77.85 203.61 88.3 200.01 57.98 191.84 49.06",
    fill: "#f4a28c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200.78,62.7a10.58,10.58,0,0,1-5.15-3.25s.09,5.36,5.84,10.8Z",
    fill: "#ce8172",
    opacity: 0.31
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 93.93,
    y: 126.09,
    width: 187.89,
    height: 115.2,
    rx: 12,
    fill: "#e6e6e6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "128.32 218.91 147.88 268.01 168.56 218.91 128.32 218.91",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M246.93,126.09s-11.81-8.38-16.64-2.2S236.2,139.29,246.93,126.09Z",
    fill: "#f4a28c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M204.91,47s1.76,8.76.93,14.81a4.47,4.47,0,0,1-5.08,3.82c-3-.46-7-2-8.53-6.54l-3.52-7.46s-2.05-4.75,2.56-8.91S204.11,41.63,204.91,47Z",
    fill: "#f4a28c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M205.74,52.6l2.86,3.14a1.43,1.43,0,0,1-.64,2.33l-3.33,1Z",
    fill: "#f4a28c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M189,60.89l-3-11.76s-6.78-1.18-4.72-5.61S186,42.06,186.1,37s4.25-6.1,7.16-3.23,1.57-1.13,5.22-1.66,4.61,1.11,4.69,3.88,5.35-.16,6.69,3.35,1.52,6.92-7.56,7.45S199.69,54.81,189,60.89Z",
    fill: "#24285b"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M196.33,55.68s-.45-3.41-3-2.86-1.92,5.48,1.63,5.55Z",
    fill: "#f4a28c"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M151.42,81.75s20,11.29,22.67,44.34H153.92Z",
    opacity: 0.09
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.42,81.75s-29.94,8.7-25.28,44.34H158S161.32,95.19,151.42,81.75Z",
    fill: "#00288f",
    className: "target-color"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M151.42,81.75s-29.94,8.7-25.28,44.34H158S161.32,95.19,151.42,81.75Z",
    fill: "#fff",
    opacity: 0.44
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M174.09,126.09s5.78-11.87,14.17-7.26S192.34,131.61,174.09,126.09Z",
    fill: "#f4a28c"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 148.91,
    y: 152.19,
    width: 16.51,
    height: 18.21,
    fill: "#ffd200"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 148.91,
    y: 152.19,
    width: 16.51,
    height: 18.21,
    opacity: 0.09
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 137.37,
    y: 159.3,
    width: 16.64,
    height: 16.64,
    fill: "#ffd200"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M114.33,162.24h11.36a4.82,4.82,0,0,1,4.75,4l4.92,26.92a5.3,5.3,0,0,0,5.21,4.34h25.31",
    fill: "none",
    stroke: "#24285b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M130.72,167.73h40a4.45,4.45,0,0,1,4.18,6l-3.24,8.94a10,10,0,0,1-9.41,6.59H135.62Z",
    fill: "#24285b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 141.62,
    cy: 205.06,
    r: 3.49,
    fill: "#24285b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.93,
    cy: 205.06,
    r: 3.49,
    fill: "#24285b"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.25,
    cy: 170.67,
    r: 9.4,
    fill: "#00288f",
    className: "target-color"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "168.1 170.67 170.5 173.85 174.37 167.74",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 201.83,
    y: 153.3,
    width: 31.4,
    height: 9.3,
    fill: "#c1c1c1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 201.83,
    y: 170.77,
    width: 57.71,
    height: 9.3,
    fill: "#c1c1c1",
    opacity: 0.49
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 201.83,
    y: 189.23,
    width: 57.71,
    height: 15.84,
    fill: "#ffd200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderConfirmation);
export default __webpack_public_path__ + "static/media/order-confirmation.d6df312252c42a0b669f3938d0385f65.svg";
export { ForwardRef as ReactComponent };